{ "imageTag": "20261105161508_13997de", "buildUri": "vstfs:///Build/Build/104461", "buildId": "104461", "sourceCommit": "13997de65580e4f8de3b99d0c31d6bf724715620", "sourceBranch": "main", "releaseDate": "2026-11-05T16:19:16Z" }
